module.exports = __webpack_public_path__ + "img/photo_2023-12-01 19.34.58.e52f5dad.jpg";